module.exports = __webpack_public_path__ + "img/img_safety_phone_img2.724ca3a9.png";